/**
 * rewards — the `?`-block / brick reward-token → (type, props) map (Brief 010).
 *
 * The level format keeps a block's `reward` as a plain string (schema-light, no enum
 * coupling in authored JSON). Brief 009 emitted COIN only; Brief 010 widens it to the
 * power-up pickups. This mapping lives in its OWN module (not spawnEntity.ts) so QBlock
 * and Brick can import it without a cycle through the spawn factory that imports THEM.
 *
 * Unknown tokens fall back to COIN, so an authoring typo never crashes or spawns nothing.
 */
import { EntityType } from '../LevelFormat';

/** A reward emitted by a head-bonk: the entity type + the props it spawns with. */
export interface RewardSpec {
  type: EntityType;
  props?: Record<string, unknown>;
}

/**
 *   'COIN'                 → COIN
 *   'ITEM_HEART'           → ITEM { kind: 'heart' }
 *   'ITEM_HEART_CONTAINER' → ITEM { kind: 'heartContainer' }
 *   'ITEM_STAR'            → ITEM { kind: 'star' }
 *   (anything else)        → COIN  (safe fallback)
 */
export function resolveRewardToken(token: string): RewardSpec {
  switch (token) {
    case 'ITEM_HEART':           return { type: EntityType.ITEM, props: { kind: 'heart' } };
    case 'ITEM_HEART_CONTAINER': return { type: EntityType.ITEM, props: { kind: 'heartContainer' } };
    case 'ITEM_STAR':            return { type: EntityType.ITEM, props: { kind: 'star' } };
    case 'COIN':                 return { type: EntityType.COIN };
    default:                     return { type: EntityType.COIN };
  }
}
